module.exports = __webpack_public_path__ + "russia.svg?6e8cc30d0459394d1b354fe292913564";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/russia.svg
// module id = 276
// module chunks = 10